import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";
import { decrypt, encrypt } from "./crypto";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { hideToast } from "../store/toastSlice";

// export const messageNotification = (
//   text,
//   type,
//   autoClose = 3000,
//   position = "top-right"
// ) => {
//   toast[type](text, {
//     position: position,
//     autoClose: autoClose,
//     hideProgressBar: false,
//     closeOnClick: true,
//     pauseOnHover: true,
//     draggable: true,
//     progress: undefined,
//   });
// };

export const useDecodeToken = () => {
  const token = useSelector((state) => state.usertoken.token);

  if (!token || token === undefined) {
    return <Navigate to="/login" />; // You can handle this case as needed
  }

  const parts = token.split(".");

  // Check if the token has 3 parts
  if (parts.length !== 3) {
    return <Navigate to="/login" />; // Handle invalid token format
  }

  const [header, payload, signature] = parts;

  try {
    return JSON.parse(atob(payload));
  } catch (error) {
    return <Navigate to="/login" />;
  }
};

export const ProtectedRoutes = () => {
  const token = useSelector((state) => state.usertoken.token);
  return token ? <Outlet /> : <Navigate to="/login" />;
};
// export const ProtectedRoutesforLoggedIn = () => {
//   const token = useSelector((state) => state.usertoken.token);

//   return !token ? <Outlet /> : <Navigate to="/" />;
// };
export const ProtectedRoutesforLoggedIn = () => {
  const token = useSelector((state) => state.usertoken.token);
  const decodedToken = useDecodeToken(); // Decodes the token

  if (!token) {
    return <Outlet />;
  }

  return decodedToken?.role == 5 ? (
    <Navigate to="/eca-audits" />
  ) : (
    <Navigate to="/" />
  );
};
function decodeBase64Url(encoded) {
  const base64 = encoded?.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(base64));
  } catch (error) {
    return null;
  }
}

// Split the token into parts

export const RoleProtectedRoute = ({ allowedRoles }) => {
  const token = useSelector((state) => state.usertoken.token);
  const decodedToken = useDecodeToken();
  // If the user is not logged in, redirect to login
  if (!token) return <Navigate to="/login" />;
  // if(decodedToken?.role == 5) return  <Navigate to="/eca-audits" />
  // console.log(decodedToken?.role == 5,"constionnnn")
  // If the user's role is not allowed, redirect to home
  if (!allowedRoles.includes(decodedToken?.role))
    return decodedToken?.role == 5 ? (
      <Navigate to="/eca-audits" />
    ) : (
      <Navigate to="/" />
    );

  return <Outlet />;
};

export const apiEncrypted = async (args, api, extraOptions) => {
  // console.log(args.body,"args.body");
  // console.log(args.url,"args.url");

  const encryptedUrl = encrypt(args.url);
  // console.log(encryptedUrl,"encryptedUrl");

  const encryptedBody = args.body ? encrypt(JSON.stringify(args.body)) : null;

    // Encrypt params if present
    // const encryptedParams = args.params ? encrypt(JSON.stringify(args.params)) : null;
  const encryptedParams = args?.params
    ? Object.entries(args?.params).reduce((acc, [key, value]) => {
        acc[key] = encrypt(String(value));
        return acc;
      }, {})
    : null;
  //  const dat = decrypt(encryptedParams)
  // console.log(encryptedParams, "encryptedParams");
// console.log(dat,"dat");

  const modifiedArgs = {
    ...args,
    url: `${encryptedUrl}`,
    body: encryptedBody ? { encryptedData: encryptedBody } : undefined,
    // params: encryptedParams || undefined,
  };
  const result = await fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_ROUTE,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.usertoken?.token;
      if (token) {
        headers.set("authorization", `${token}`);
      }
      return headers;
    },
  })(modifiedArgs, api, extraOptions);

  // Decrypt response
  // console.log(result,"result");
  // if (result.data) {
  //   let data = = decrypt(result.data);
  // }
  return result;
};

export const convertDDMMYYYY = (date) => {
  if (!date || !(date instanceof Date) || isNaN(date)) {
    console.error("Invalid date detected in convertDDMMYYYY");
    return "";
  }
  // Extract day, month, and year
  const day = String(date?.getDate()).padStart(2, "0"); // Pad with 0 if needed
  const month = String(date?.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date?.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};

export const convertToFullDate = (dateString) => {
  // Split the DD/MM/YYYY string
  const [day, month, year] = dateString.split("/").map(Number);

  // Create a new Date object (Month is zero-based, so subtract 1)
  const dateObject = new Date(year, month - 1, day);

  // Return the full date string
  return dateObject.toString();
};

export const hidetoast = async () => {
  const { store } = await import("../store/store");
  const timer = setTimeout(() => {
    store.dispatch(hideToast());
  }, 3000);
  return () => clearTimeout(timer);
};

export const AdminRole = [
  {
    id: 1,
    role: "Admin",
  },
  {
    id: 4,
    role: "Nobal Admin",
  },
  {
    id: 5,
    role: "ECA Admin",
  },
];


